'use strict';

import React from 'react';
import {Link} from 'react-router';
import Dialog from 'material-ui/Dialog';
import DocumentTitle from 'react-document-title';
import * as Connections from "../../utils/Connections.js";
import ReadyForDeliveryStore from "../../stores/ReadyForDeliveryOrdersStore.js";

class ReadyForDeliveryOrders extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allOrders: [],
            filteredOrders: [],
            contributingFarmers:[],
            openFarmers: false
        };
        this.updateReadyForDelivery = this.updateReadyForDelivery.bind(this);

    }

    handleViewFarmerClose() {
        this.setState({openFarmers: false});

    }

    handleViewFarmerOpen(farmers){
        this.setState({contributingFarmers:farmers,openFarmers: true});
    }
    componentWillMount() {
        this.setState({
            allOrders: ReadyForDeliveryStore.getAll(),
            filteredOrders: ReadyForDeliveryStore.getFiltered()
        });
        ReadyForDeliveryStore.on("change", this.updateReadyForDelivery);
        Connections.getReadyForDelivery();
    }

    updateReadyForDelivery() {
        this.setState({
            allOrders: ReadyForDeliveryStore.getAll(),
            filteredOrders: ReadyForDeliveryStore.getFiltered()
        });
    }

    getImageName(imageName) {
        return Connections.getProduceImageLink() + imageName.replace(" ", "").toLowerCase() + ".jpg";

    }

    render() {
        return (
            <DocumentTitle title="Khula - Billing">
                <div className="main-content">

                    <div className="uk-overflow-auto">
                        <table className="uk-table uk-table-hover uk-table-responsive uk-table-middle uk-table-divider">
                            <thead>
                            <tr>
                                <th className="uk-table-shrink"></th>
                                <th className="uk-table-shrink">Produce</th>
                                <th className="uk-table-expand">Description</th>
                                <th className="uk-width-small">Ordered Date</th>
                                <th className="uk-table-shrink uk-text-nowrap">Collected (KG)</th>
                                <th className="uk-table-shrink uk-text-nowrap">Navigate</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.filteredOrders.map((order, i) =>
                                <tr key={order.order_id}>
                                    <td><img className="avalibleImage uk-preserve-width uk-border-circle"
                                             src={this.getImageName(order.produce)}  width="40" alt=""/></td>
                                    <td className="">{order.produce}</td>
                                    <td className="uk-table-link">
                                        <span className="uk-link-reset">{order.description}</span>
                                    </td>
                                    <td className="uk-text-nowrap">
                                        <p className="uk-text-meta uk-margin-remove-top">
                                            <time>{order.inserted_on}</time>
                                        </p>
                                    </td>
                                    <td className="uk-text-nowrap">{order.quantity - order.quantity_left}/{order.quantity} kg</td>
                                    <td><a
                                           onClick={() => this.handleViewFarmerOpen(order.farmers)}>View Farmers</a></td>
                                </tr>
                            )}

                            </tbody>
                        </table>
                    </div>
                    <Dialog
                        title={<h3 className="uk-modal-title">Farmers</h3>}
                        modal={false}
                        open={this.state.openFarmers}
                        onRequestClose={() => this.handleViewFarmerClose()}
                        autoScrollBodyContent={true}>
                        <table className="checkout-table">
                            <thead>
                            <tr>
                                <th className="checkout-heading">Farmer Name</th>
                                <th className="checkout-heading">Address</th>
                                <th className="checkout-heading">Collect Quantity(KGs)</th>
                                <th className="checkout-heading">Phone Number</th>
                                <th className="checkout-heading">Open Google Maps</th>
                            </tr>
                            </thead>

                            <tbody>
                            {
                                this.state.contributingFarmers.map((farmer, i) => {
                                    console.log(farmer);
                                    var clas;
                                    i % 2 == 1 ? (clas = "even") : (clas = "");
                                    return (
                                        <tr key={i} className={"checkout-item-row " + clas} id={farmer.id}>
                                            <td>{farmer.name +" "+ farmer.surname}</td>
                                            <td>{farmer.address}</td>
                                            <td>{farmer.quantity}</td>
                                            <td>{farmer.phone}</td>
                                            <td><a href={"https://www.google.com/maps/search/?api=1&zoom=12&query="+farmer.farmlatlong}>View on map</a></td>
                                        </tr>
                                    )
                                })
                            }
                            {/**/}
                            </tbody>
                        </table>
                    </Dialog>
                </div>
            </DocumentTitle>
        );
    }

}

export default ReadyForDeliveryOrders;



// WEBPACK FOOTER //
// ./src/pages/HopePageBabies/ReadyForDeliveryOrders.js